import React from 'react';
import { Box } from '@mui/material';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import matmanHelperButton from 'assets/images/matman-helper-button.png';
import matmanSelectedHelperButton from 'assets/images/matman-selected-helper-button.png';
import ImageButton from './ImageButton';
import { AppRoutes } from 'types';

const tA11y = (key: string) => translate('a11y', key);

type Props = {
  styles?: React.CSSProperties;
  components?: any;
  noRedirect?: boolean;
};

const MatmanHelperButton: React.FC<Props> = (props) => {
  const { styles, components, noRedirect, ...rest } = props;
  return (
    <Box style={styles}>
      <ImageButton
        hoveredImgSrc={matmanSelectedHelperButton}
        notHoveredImgSrc={matmanHelperButton}
        imgAlt={tA11y('alt.matmanHelperButton')}
        redirectRoute={
          noRedirect
            ? undefined
            : { path: `/${AppRoutes.TOUR}/${AppRoutes.ONBOARDING}`, title: AppRoutes.TOUR as any }
        }
        style={styles}
        {...rest}
      />
      {components && <div>{components}</div>}
    </Box>
  );
};

export default MatmanHelperButton;
